module.exports = __webpack_public_path__ + "img/signinTraining.1d7c0d22.png";